import {HttpErrorResponse} from '@angular/common/http';
import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {GateweeMultiSelectOption} from '@gatewee/components/v2';
import {companyTypes} from '@gatewee/types/onboarding';
import {
  Recipient,
  recipientBusinessAreaOptions,
} from '@gatewee/types/recipient';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {mapCompanyType} from '../../../../../utils/onboarding.util';
import {PublicService} from '../../../../_services/public/public.service';

@Component({
  selector: 'app-business-form',
  templateUrl: './business-form.component.html',
  styleUrls: ['./business-form.component.css'],
  standalone: false,
})
export class BusinessFormComponent implements OnInit, OnDestroy {
  @Input() formGroup!: FormGroup;

  companyTypes = companyTypes;

  businessAreaItems: GateweeMultiSelectOption<string>[] = [];

  private langChangeSub?: Subscription;

  constructor(
    private publicService: PublicService,
    private readonly translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.buildBusinessAreaItems();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.buildBusinessAreaItems();
    });
  }

  ngOnDestroy(): void {
    this.langChangeSub?.unsubscribe();
  }

  private buildBusinessAreaItems(): void {
    this.businessAreaItems = recipientBusinessAreaOptions.map(option => ({
      value: option.value,
      label: this.translate.instant(`enums.businessArea.${option.value}`),
    }));
  }

  fetchCompanyData() {
    if (this.formGroup.get('document')?.valid) {
      const document = this.formGroup.get('document')?.value;

      this.publicService.findOfficialData(document).subscribe({
        next: (data: Partial<Recipient>) => {
          if (data) {
            this.formGroup
              .get('officialData')
              ?.patchValue(data.officialData || {});
            this.formGroup.patchValue({
              name: data.officialData?.company.name || '',
              displayName: data.officialData?.alias || '',
              companyType: mapCompanyType(
                data.officialData?.company.nature?.id ?? 2002,
              ),
              businessAreas: data.businessAreas || [],
            });
          }
        },
        error: (error: HttpErrorResponse) => {
          if (error.status === 409) {
            this.formGroup.get('document')?.setErrors({alreadyExists: true});
          }
        },
      });
    }
  }
}
